import { RichEditor } from "@/components/pages/pages-form";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/posts/new-page")({
  component: () => <RichEditor initialTitle="New Page" />,
});
